
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { AppConfigService } from './app-config.service';

@Injectable()

export class TranslateLoaderService {

    constructor(private http: HttpClient) {

    }

    getTranslation(lang: string): Observable<any> {
        // console.log("getTranslation")

        if (AppConfigService.settings.translate.loadFromRemote && !!AppConfigService.settings.translate.resourceURL) {
            // Load translations from remote server
            const params = { type: 101, code: lang };
            const url = AppConfigService.settings.translate.resourceURL.endsWith('/') ? AppConfigService.settings.translate.resourceURL : AppConfigService.settings.translate.resourceURL + '/';
            return this.http.get(url, { params });
        } else {

            const timestamp = `?ts=${new Date().getTime()}`;;
            if (!!AppConfigService.settings.translate.resourceURL) {
                const url = AppConfigService.settings.translate.resourceURL.endsWith('/') ? AppConfigService.settings.translate.resourceURL : AppConfigService.settings.translate.resourceURL + '/';;
                return this.http.get(`${url}${lang}.json${timestamp}`)
            }
            else {
                return this.http.get(`/assets/i18n/${lang}.json${timestamp}`)
            }
        }
    }
}